export const CLASS_TEMPLATE_BULK_UPDATE_TYPES = {
  academyTopics: 'bulk_update_academy_topics',
  courseGroups: 'bulk_update_course_groups',
  lectureContents: 'bulk_update_lecture_contents',
  lessons: 'bulk_update_lessons',
  playlists: 'bulk_update_playlist_contents',
  academyProjects: 'bulk-update-academy-projects',
  classTag: 'bulk_update_class_tag_contents',
} as const;
